<template>
  <span class="relative inline-block">
    <slot />
    <span
      v-if="visible"
      :class="[badgeColorClass, badgeSizeClass]"
      class="absolute right-1 top-0 inline-block translate-x-1/2 transform rounded-full"
    />
  </span>
</template>
<script>
export default {
  name: 'IconBadge',
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    badgeColor: {
      type: String,
      default: 'yellow',
      validator: function (value) {
        // The value must match one of these strings
        return ['yellow', 'red'].includes(value);
      },
    },
    badgeSize: {
      type: String,
      default: 'md',
      validator: function (value) {
        // The value must match one of these strings
        return ['sm', 'md', 'lg'].includes(value);
      },
    },
  },
  computed: {
    badgeColorClass() {
      if (this.badgeColor === 'yellow') {
        return 'bg-badge-yellow';
      }
      return 'bg-red-500';
    },
    badgeSizeClass() {
      switch (this.badgeSize) {
        case 'sm':
          return 'w-2 h-2';
        case 'md':
          return 'w-3 h-3';
        default:
          return 'w-4 h-4';
      }
    },
  },
};
</script>
<style scoped></style>
